import React, { useState, useRef, useEffect } from "react";
import {
  Upload as UploadIcon,
  FileText,
  Brain,
  Target,
  CheckCircle,
  Star,
  Users,
  Calendar,
  ChevronRight,
  X,
  Briefcase,
  Code,
  Database,
  Cloud,
  Zap,
  MapPin, Mail, Phone, ChevronDown, ChevronUp, Award, AlertCircle, CheckCircle2
} from "lucide-react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  InputGroup,
  ProgressBar,
  Spinner,
  Badge,
  Alert,
  ListGroup,
  Modal,
} from "react-bootstrap";
import { Tabs, Tab } from "react-bootstrap";
import { FaEnvelope, FaPhone, FaEdit } from "react-icons/fa";
import { resumeAiScanner, resumeSingleMail, resumeBulkMail, candidateEdit, extraResumeAiScanner } from "../services/auth";
// import { toastError, toastSuccess } from "../config/ToastModal";
import { useNavigate } from "react-router-dom";
import ResumeViewer from "./ResumeViewer";
import { toastError, toastSuccess } from "../config/ToastModal";

const ResumeParserNew = () => {
  const navigate = useNavigate()
  const [currentStep, setCurrentStep] = useState(1);
  const [uploadedResumes, setUploadedResumes] = useState([]);
  const [selectedJobTitle, setSelectedJobTitle] = useState("");
  const [mandatorySkills, setMandatorySkills] = useState([]);
  const [skillInput, setSkillInput] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [analysisResults, setAnalysisResults] = useState([]);
  const [jobDescription, setJobDescription] = useState("");
  const [showUploadOptions, setShowUploadOptions] = useState(false);
  const [activeTab, setActiveTab] = useState("manual");
  const [uploadResumeData, setUploadResumeData] = useState([]);
  const [responseData, setResponseData] = useState();
  const [responseBatchId, setResponseBatchId] = useState("");
  const [batchName, setBatchName] = useState("");
  const [jobId, setJobId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedForMail, setSelectedForMail] = useState([]);
  const [batchId, setBatchId] = useState("")
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedLevel, setSelectedLevel] = useState('');
  const [questionCount, setQuestionCount] = useState('');
  const [firstBatchId, setFirstBatchId] = useState('');
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [expandedCards, setExpandedCards] = useState(new Set());
  const [showExtraLoading, setShowExtraLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const fileInputRef = useRef(null);
  const [showPDF, setShowPDF] = useState(false);
  const formData = new FormData();
  const [showEditModal, setShowEditModal] = useState(false);
  const [editCandidate, setEditCandidate] = useState({
    name: "",
    email: "",
    mobile: "",
  });


  const jobTitles = [
    "Senior Software Engineer",
    "Full Stack Developer",
    "Backend Developer",
    "Frontend Developer",
    "DevOps Engineer",
    "Data Scientist",
    "Product Manager",
    "UI/UX Designer",
    "Mobile App Developer",
    "System Architect",
  ];

  const suggestedSkills = {
    "Senior Software Engineer": [
      "JavaScript",
      "React",
      "Node.js",
      "Python",
      "AWS",
      "Docker",
      "Git",
      "REST APIs",
    ],
    "Full Stack Developer": [
      "JavaScript",
      "React",
      "Node.js",
      "MongoDB",
      "Express",
      "HTML/CSS",
      "Git",
    ],
    "Backend Developer": [
      "Python",
      "Java",
      "Node.js",
      "SQL",
      "REST APIs",
      "Docker",
      "AWS",
      "Git",
    ],
    "Frontend Developer": [
      "JavaScript",
      "React",
      "HTML/CSS",
      "TypeScript",
      "Vue.js",
      "Webpack",
      "Git",
    ],
    "DevOps Engineer": [
      "Docker",
      "Kubernetes",
      "AWS",
      "Jenkins",
      "Terraform",
      "Linux",
      "Git",
      "CI/CD",
    ],
    "Data Scientist": [
      "Python",
      "R",
      "SQL",
      "Machine Learning",
      "TensorFlow",
      "Pandas",
      "Statistics",
    ],
    "Product Manager": [
      "Product Strategy",
      "Agile",
      "Analytics",
      "User Research",
      "Roadmapping",
    ],
    "UI/UX Designer": [
      "Figma",
      "Adobe XD",
      "Sketch",
      "Prototyping",
      "User Research",
      "Wireframing",
    ],
    "Mobile App Developer": [
      "React Native",
      "Flutter",
      "iOS",
      "Android",
      "JavaScript",
      "Swift",
      "Kotlin",
    ],
    "System Architect": [
      "System Design",
      "Microservices",
      "AWS",
      "Docker",
      "Kubernetes",
      "Scalability",
    ],
  };

  const handleFileUpload = (event) => {
    const allowedTypes = [
      "application/pdf",
      "application/msword", // .doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    ];

    const files = Array.from(event.target.files);
    let invalidFiles = [];

    const newResumes = files
      .map((file, index) => {
        if (!allowedTypes.includes(file.type)) {
          invalidFiles.push(file.name);
          return null;
        }

        const resumeId = Date.now() + index;

        return {
          id: resumeId,
          name: file.name,
          size: (file.size / 1024 / 1024).toFixed(2) + " MB",
          type: file.type,
          status: "uploaded",
          file, // keep actual File here for FormData
        };
      })
      .filter(Boolean);

    if (invalidFiles.length > 0) {
      toastError("Only PDF, DOC, and DOCX formats are supported.");
    }

    setUploadedResumes((prev) => [...prev, ...newResumes]);
    setUploadResumeData((prev) => [...prev, ...newResumes.map((r) => ({ id: r.id, file: r.file }))]);

    // 🔑 Reset input so same file can be chosen again
    event.target.value = "";
  };

  const addSkill = () => {
    if (skillInput.trim() && !mandatorySkills.includes(skillInput.trim())) {
      setMandatorySkills((prev) => [...prev, skillInput.trim()]);
      setSkillInput("");
    }
  };

  const removeSkill = (skillToRemove) => {
    setMandatorySkills((prev) =>
      prev.filter((skill) => skill !== skillToRemove)
    );
  };

  const addSuggestedSkill = (skill) => {
    if (!mandatorySkills.includes(skill)) {
      setMandatorySkills((prev) => [...prev, skill]);
    }
  };

  const removeResume = (id) => {
    setUploadedResumes((prevResumes) => prevResumes.filter((resume) => resume.id !== id));
    setUploadResumeData((prevData) => prevData.filter((resume) => resume.id !== id));
  };

  const isFormValid = () => {
    if (!batchName?.trim()) return false;
    if (!jobId?.trim()) return false;
    if (!jobDescription?.trim()) return false;
    if (!selectedLevel?.trim()) return false;
    if (!selectedRole?.trim()) return false;
    if (!questionCount || isNaN(questionCount)) return false;
    if (Number(questionCount) < 5) return false;
    if (mandatorySkills.length === 0) return false;
    if (uploadResumeData.length === 0) return false;

    return true;
  };

  const analyzeResumes = async () => {
    let resultCounter = 1;
    if (activeTab === "existingJob" && mandatorySkills.length === 0) {
      alert("Please add at least one mandatory skill");
      return;
    }

    if (!isFormValid()) {
      alert("Please fill all the required fields before analyzing resumes.");
      return;
    }

    if (!batchName) return;

    setIsProcessing(true);
    setCurrentStep(3);
    setAnalysisResults([]); // clear old data

    const buildFormData = (resumes) => {
      const formData = new FormData();
      resumes.forEach((resume) => formData.append("resumes", resume.file));
      formData.append("batchName", batchName);
      formData.append("jobId", jobId);
      formData.append("jobDescription", jobDescription);
      formData.append("level", selectedLevel);
      formData.append("role", selectedRole);
      formData.append("questionCount", Number(questionCount));
      formData.append("techStack", mandatorySkills.join(", "));
      return formData;
    };

    const processResponseData = (data, startIndex = 1) => {
      return data.map((resume, idx) => {
        const scoreValue = parseFloat(resume["Overall_Score"]);
        let ratingData = {
          rating: "Average",
          score: scoreValue,
          color: "danger",
          textColor: "text-warning",
          bgColor: "bg-warning-light",
        };

        if (scoreValue >= 90) {
          ratingData = {
            rating: "Perfect",
            score: scoreValue,
            color: "success",
            textColor: "text-success",
            bgColor: "bg-success-light",
          };
        } else if (scoreValue >= 75) {
          ratingData = {
            rating: "Good",
            score: scoreValue,
            color: "primary",
            textColor: "text-primary",
            bgColor: "bg-primary-light",
          };
        }

        return {
          serialNo: startIndex + idx, // 👈 Add running index
          id: startIndex + idx,
          name: resume?.Name?.trim(),
          email: resume["Email"],
          mobile: resume["Mobile_No"],
          skills: resume["Skills"],
          score: scoreValue,
          recommendation: resume?.Recommendation,
          justification: resume?.Justification,
          matchLevel: resume["Match_Level"],
          fileName: resume["File_Name"],
          ...ratingData,
          matchedSkills: resume["Matched_Skills"],
          missingSkills: resume["Missing_Skills"],
          negative: resume["Negative_Aspects"],
          positive: resume["Positive_Aspects"],
        };
      });
    };


    try {
      const batchSize = 5;
      const allChunks = [];
      for (let i = 0; i < uploadResumeData.length; i += batchSize) {
        allChunks.push(uploadResumeData.slice(i, i + batchSize));
      }

      let batchId = "";

      // First Batch - show immediately
      const firstFormData = buildFormData(allChunks[0]);
      const firstResponse = await resumeAiScanner(firstFormData);
      batchId = firstResponse?.data?.batchId || "";
      setFirstBatchId(batchId);
      setResponseBatchId(batchId);
      setBatchId(batchId);

      const firstResults = processResponseData(firstResponse?.data?.data || [], resultCounter);
      resultCounter += firstResults.length;

      setAnalysisResults(firstResults);
      setResponseData(firstResponse?.data?.data || []);

      // If more batches exist
      if (allChunks.length > 1) {
        setIsProcessing(false)
        setShowExtraLoading(true);

        // Loop through remaining batches
        for (let i = 1; i < allChunks.length; i++) {
          const formData = buildFormData(allChunks[i]);
          formData.append("batchId", batchId);
          await new Promise((resolve) => setTimeout(resolve, 40000));

          const extraResponse = await extraResumeAiScanner(formData);
          const nextResults = processResponseData(extraResponse?.data?.data || [], resultCounter);
          resultCounter += nextResults.length;

          // Append results
          setAnalysisResults((prev) => [...prev, ...nextResults]);
          setResponseData((prev) => [...prev, ...(extraResponse?.data?.data || [])]);

          if (i === allChunks.length - 1) {
            setShowExtraLoading(false); // ⬅️ hide loader
          }
        }
      }
    } catch (err) {
      console.error("Error analyzing resumes:", err);
      alert("Something went wrong while analyzing resumes.");
    }

    setIsProcessing(false);
  };

  useEffect(() => {
    if (responseData) {
      console.log(responseData, "✅ response after state update");
    }
  }, [responseData]);

  const navigateToInterview = (candidate) => {
    alert(
      `Navigating to interview scheduling for ${candidate.name.replace(
        /\.[^/.]+$/,
        ""
      )}`
    );
  };

  const [provider, setProvider] = useState('');
  const [bucketName, setBucketName] = useState('');
  const [accessKey, setAccessKey] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [region, setRegion] = useState('');
  const [connecting, setConnecting] = useState(false);
  const [cloudShow, setCloudShow] = useState(false);

  const handleConnect = () => {
    setConnecting(true);
    setTimeout(() => {
      setConnecting(false);
      alert('Connected successfully');
      setProvider('');
      setBucketName('');
      setAccessKey('');
      setSecretKey('');
      setRegion('');
      setCloudShow(false);
    }, 2000);
  };

  const cloudUploadClick = () => setCloudShow(true);
  const handleClose = () => setCloudShow(false);

  const canProceedToStep2 = uploadedResumes.length > 0 && batchName.length > 0 && jobId.length > 0;
  const canProceedToStep3 = selectedJobTitle && mandatorySkills.length > 0;

  const toggleCardExpansion = (id) => {
    const newSet = new Set(expandedCards);
    newSet.has(id) ? newSet.delete(id) : newSet.add(id);
    setExpandedCards(newSet);
  };

  const handleSelection = (id, checked) => {
    setSelectedCandidates((prev) =>
      checked ? [...prev, id] : prev.filter((c) => c !== id)
    );
  };

  console.log(analysisResults, "analysisResultsanalysisResults")

  const handleSendMail = () => {
    const selected = analysisResults?.filter((c) =>
      selectedCandidates.includes(c.serialNo)
    );
    console.log(selected, "selected--")
    setSelectedForMail(selected);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const selectedMailSend = async () => {
    setIsSending(true);          // 🔁 Start loading
    try {
      if (selectedForMail.length > 1) {
        // Bulk mail case
        const payload = selectedForMail.map((item) => ({
          candidateEmail: item.email,
          candidateName: item.name,
          batchId: batchId,
        }));

        console.log(payload, "bulk payload ----");

        const response = await resumeBulkMail({ candidates: payload });
        toastSuccess(response?.data?.message);
        setShowModal(false);
        navigate("/interview-schedule");
      } else if (selectedForMail.length === 1) {
        // Single mail case
        const single = selectedForMail[0];
        const payload = {
          candidateEmail: single.email,
          candidateName: single.name,
          batchId: batchId,
        };

        console.log(payload, "single payload ----");

        const response = await resumeSingleMail(payload);
        toastSuccess(response?.data?.message);
        setShowModal(false);
        navigate("/interview-schedule");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSending(false);
    }
  };

  const HandleEdit = async (candidate, id) => {
    const payload = {
      batchId: responseBatchId,
      responseId: id,
      name: candidate.name,
      email: candidate.email,
      mobile: candidate.mobile,
    };

    try {
      const response = await candidateEdit(payload);
      toastSuccess(response?.data?.message || "Candidate updated successfully");

      const updatedList = responseData.map((item) =>
        item.Id === id
          ? {
            ...item,
            Name: candidate.name,
            Email: candidate.email,
            Mobile_No: candidate.mobile,
          }
          : item
      );
      setResponseData(updatedList);

      const updatedAnalysis = analysisResults.map((c) =>
        c.id === id
          ? {
            ...c,
            name: candidate.name,
            email: candidate.email,
            mobile: candidate.mobile,
          }
          : c
      );
      setAnalysisResults(updatedAnalysis);

      setShowEditModal(false);
    } catch (error) {
      console.error("Edit failed:", error);
    }
  };
  console.log(responseData, "responseData")

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <div className="bg-white shadow-sm border-bottom">
        <Container className="py-4">
          <Row className="align-items-center">
            <Col>
              <div className="d-flex align-items-center">
                <div className="bg-gradient-primary p-2 rounded-xl me-3">
                  <Brain className="text-white" size={24} />
                </div>
                <div>
                  <h1 className="h2 mb-0 text-dark">Smart Resume Screener</h1>
                  <p className="text-muted mb-0">
                    AI-powered candidate matching system
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Progress Steps */}
      <Container className="py-5">
        <Row className="justify-content-center mb-5">
          {[
            { step: 1, title: "Upload Resumes", icon: UploadIcon },
            { step: 2, title: "Job Requirements", icon: Briefcase },
            { step: 3, title: "Match Results", icon: Target },
          ].map((item, index) => (
            <React.Fragment key={item.step}>
              <Col xs="auto">
                <div
                  className={`d-flex align-items-center`}
                  style={{
                    color: currentStep >= item.step ? "#97144d" : "#6c757d",
                  }}
                >
                  <div
                    className={`rounded-circle border d-flex align-items-center justify-content-center`}
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: currentStep >= item.step ? "#97144d" : "#f0f0f0",
                      color: currentStep >= item.step ? "white" : "#6c757d",
                    }}
                  >
                    {currentStep > item.step ? (
                      <CheckCircle size={20} />
                    ) : (
                      <item.icon size={20} />
                    )}
                  </div>
                  <span className="ms-2 fw-medium">{item.title}</span>
                </div>
              </Col>
              {index < 2 && (
                <Col xs="auto">
                  <ChevronRight className="text-muted mt-2" size={20} />
                </Col>
              )}
            </React.Fragment>
          ))}
        </Row>

        {/* Step 1: Upload Resumes */}
        {currentStep === 1 && (
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-5">
              <div className="text-center mb-5">
                <h2 className="h3 mb-2">Upload Candidate Resumes</h2>
                <p className="text-muted">
                  Upload multiple resumes to get started with AI-powered
                  screening
                </p>
              </div>

              <Card className="p-5 text-center hover-border-primary cursor-pointer" style={{ border: "1px solid #97144d" }}>
                <div className="d-flex justify-content-center mb-4">
                  <UploadIcon size={64} style={{ color: "#97144d" }} />
                </div>

                <h3 className="h5 mb-2">
                  Drop resumes here or click to browse
                </h3>

                <p className="text-muted mb-4">
                  Supports PDF, DOC, DOCX formats
                </p>
                <div className="d-flex justify-content-center mb-4">
                  <Button
                    style={{ backgroundColor: "#97144d", borderColor: "#97144d", width: "30%" }}
                    onClick={() => setShowUploadOptions(true)}
                  >
                    Choose Files
                  </Button>
                </div>
                <Form.Control
                  ref={fileInputRef}
                  type="file"
                  multiple
                  accept=".pdf,.doc,.docx,"
                  onChange={handleFileUpload}
                  className="d-none"
                />
              </Card>

              {uploadedResumes.length > 0 && (
                <div className="mt-5">
                  <h3 className="h5 mb-3">
                    Uploaded Resumes ({uploadedResumes.length})
                  </h3>
                  <Row className="g-3 mb-4">
                    {uploadedResumes.map((resume) => (
                      <Col key={resume.id} md={6}>
                        <Card className="border">
                          <Card.Body className="d-flex justify-content-between align-items-center p-3">
                            <div className="d-flex align-items-center">
                              <FileText
                                className="text-primary me-3"
                                size={24}
                              />
                              <div>
                                <p className="fw-medium mb-0">{resume.name}</p>
                                <small className="text-muted">
                                  {resume.size}
                                </small>
                              </div>
                            </div>
                            <Button
                              variant="link"
                              className="text-danger p-0"
                              onClick={() => removeResume(resume.id)}
                            >
                              <X size={16} />
                            </Button>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group controlId="batchName">
                        <Form.Label className="h5">Batch Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter a Batch Name"
                          onChange={(e) => setBatchName(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="jobId">
                        <Form.Label className="h5">Job Id</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter a Job Id"
                          onChange={(e) => setJobId(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="d-flex justify-content-center">
                    <Button
                      onClick={() => setCurrentStep(2)}
                      disabled={!canProceedToStep2}
                      className="w-50 py-3"
                      style={{ backgroundColor: "#97144d", border: "none" }}
                    >
                      Continue to Job Requirements <ChevronRight size={20} />
                    </Button>
                  </div>

                </div>
              )}
            </Card.Body>
          </Card>
        )}

        {/* Upload Options Modal */}
        <Modal
          show={showUploadOptions}
          onHide={() => setShowUploadOptions(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Select Upload Source</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-grid gap-3">
              <Button
                variant="outline-primary"
                onClick={() => {
                  setShowUploadOptions(false);
                  fileInputRef.current?.click();
                }}
              >
                Upload from Device
              </Button>

              <Button
                variant="outline-success"
                onClick={() => {
                  setShowUploadOptions(false);
                  cloudUploadClick()
                }}
              >
                Upload from Cloud
              </Button>

              <Button
                variant="outline-info"
                onClick={() => {
                  setShowUploadOptions(false);
                  alert("Upload Excel File not implemented.");
                }}
              >
                Upload Excel File
              </Button>

              <Button
                variant="outline-secondary"
                onClick={() => {
                  setShowUploadOptions(false);
                  alert("Other Sources not implemented.");
                }}
              >
                Other Sources
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        <div className="container mt-5">
          {/* Trigger Button */}
          {/* <Button variant="success" onClick={cloudUploadClick}>
            Open Cloud Upload Modal
          </Button> */}

          {/* Cloud Upload Modal */}
          <Modal show={cloudShow} onHide={handleClose} centered size="xl">
            <Modal.Header closeButton>
              <Modal.Title>Cloud Upload</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                {/* Add New Connection */}
                <div className="col-md-6">
                  <div className="card border-0">
                    <div className="card-body">
                      <h5 className="card-title mb-3">Add New Connection</h5>

                      <div className="mb-3">
                        <label className="form-label">Provider</label>
                        <select className="form-select" value={provider} onChange={(e) => setProvider(e.target.value)}>
                          <option value="">Select a provider</option>
                          <option value="aws">AWS S3</option>
                          <option value="gcs">Google Cloud Storage</option>
                          <option value="azure">Azure Blob Storage</option>
                          <option value="dropbox">Dropbox Business</option>
                          <option value="box">Box Enterprise</option>
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Bucket/Container Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={bucketName}
                          onChange={(e) => setBucketName(e.target.value)}
                          placeholder="e.g. my-bucket"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Region</label>
                        <select className="form-select" value={region} onChange={(e) => setRegion(e.target.value)}>
                          <option value="">Select region</option>
                          <option value="us-east-1">US East (N. Virginia)</option>
                          <option value="us-west-2">US West (Oregon)</option>
                          <option value="eu-west-1">EU (Ireland)</option>
                          <option value="ap-southeast-1">Asia Pacific (Singapore)</option>
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Access Key / Client ID</label>
                        <input
                          type="password"
                          className="form-control"
                          value={accessKey}
                          onChange={(e) => setAccessKey(e.target.value)}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Secret Key / Client Secret</label>
                        <input
                          type="password"
                          className="form-control"
                          value={secretKey}
                          onChange={(e) => setSecretKey(e.target.value)}
                        />
                      </div>

                      <div className="alert alert-warning p-2 small">
                        Your credentials are encrypted and stored securely.
                      </div>

                      <Button
                        variant="primary"
                        className="w-100"
                        disabled={!provider || !bucketName || !accessKey || !secretKey || connecting}
                        onClick={handleConnect}
                      >
                        {connecting ? 'Connecting...' : 'Connect Storage'}
                      </Button>
                    </div>
                  </div>
                </div>

                {/* Connection Settings */}
                <div className="col-md-6">
                  <div className="card border-0">
                    <div className="card-body">
                      <h5 className="card-title mb-3">Connection Settings</h5>

                      <div className="mb-3">
                        <label className="form-label">Sync Frequency</label>
                        <select className="form-select">
                          <option>Real-time</option>
                          <option>Every 5 minutes</option>
                          <option selected>Every 15 minutes</option>
                          <option>Hourly</option>
                          <option>Daily</option>
                        </select>
                      </div>

                      <div className="mb-3">
                        <h6>File Type Filters</h6>
                        {['CSV Files', 'JSON Files', 'Excel Files', 'Images', 'Documents'].map((type) => (
                          <div className="form-check" key={type}>
                            <input className="form-check-input" type="checkbox" defaultChecked id={type} />
                            <label className="form-check-label" htmlFor={type}>
                              {type}
                            </label>
                          </div>
                        ))}
                      </div>

                      <div className="mb-3">
                        <h6>Advanced Options</h6>
                        {['Enable versioning', 'Compress files before transfer', 'Auto-retry failed syncs'].map(
                          (opt, idx) => (
                            <div className="form-check" key={idx}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultChecked={opt === 'Auto-retry failed syncs'}
                                id={`adv-${idx}`}
                              />
                              <label className="form-check-label" htmlFor={`adv-${idx}`}>
                                {opt}
                              </label>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>

        {/* Step 2: Job Requirements */}
        {currentStep === 2 && (
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-5">
              <div className="text-center mb-5">
                <h2 className="h3 mb-2">Define Job Requirements</h2>
                <p className="text-muted">
                  Select the job title and specify mandatory skills for accurate
                  matching
                </p>
              </div>

              <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                defaultActiveKey="manual"
                className="mb-4"
              >
                <Tab eventKey="manual" title="Manual">
                  <div className="mt-4">
                    <div className="alert alert-info p-2 mb-3" role="alert">
                      <strong>Note:</strong> Fill all fields carefully — your inputs will be used to generate AI interview questions.
                    </div>
                    <div className="mb-5">
                      <Form.Label className="fw-semibold mb-3">
                        Job Description
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        placeholder="Enter the job description..."
                        value={jobDescription}
                        onChange={(e) => setJobDescription(e.target.value)}
                      />
                    </div>

                    <div className="mb-5">
                      <Form.Label className="fw-semibold mb-3">
                        Skill Stacks
                      </Form.Label>

                      <InputGroup className="mb-3">
                        <Form.Control
                          type="text"
                          value={skillInput}
                          onChange={(e) => setSkillInput(e.target.value)}
                          onKeyPress={(e) => e.key === "Enter" && addSkill()}
                          placeholder="Enter a Skill Stacks..."
                        />
                        <Button variant="primary" onClick={addSkill} style={{ backgroundColor: "#97144d", border: "none" }}>
                          Add
                        </Button>
                      </InputGroup>

                      {mandatorySkills.length > 0 && (
                        <div>
                          <p className="small fw-medium text-muted mb-2">
                            Selected mandatory skills:
                          </p>
                          <div className="d-flex flex-wrap gap-2">
                            {mandatorySkills.map((skill) => (
                              <Badge
                                key={skill}
                                bg="primary"
                                className="d-flex align-items-center"
                              >
                                {skill}
                                <Button
                                  variant="link"
                                  className="p-0 ms-2 text-white"
                                  onClick={() => removeSkill(skill)}
                                >
                                  <X size={12} />
                                </Button>
                              </Badge>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                    <Row className="d-flex w-100">
                      {/* Role Dropdown */}
                      <Col md={6}>
                        <Form.Label className="fw-semibold mb-3">Role</Form.Label>
                        <InputGroup className="mb-3">
                          <Form.Select
                            value={selectedRole}
                            onChange={(e) => setSelectedRole(e.target.value)}
                          >
                            <option value="" disabled>Select a role</option>
                            <option value="Frontend Developer">Frontend Developer</option>
                            <option value="Backend Developer">Backend Developer</option>
                            <option value="Human Resources">Human Resources</option>
                            <option value="Automation Testing">Automation Testing</option>
                            <option value="Manual Testing">Manual Testing</option>
                            <option value="Voice Process">Voice Process</option>
                            <option value="Customer Care Executive">Customer Care Executive</option>
                            <option value="Loan Collection">Loan Collection</option>
                            <option value="Pharma Sales">Pharma Sales</option>
                            <option value="CIO / CTO">CIO / CTO</option>
                            <option value="Pathologist">Pathologist</option>
                            <option value="Server Admin">Server Admin</option>
                            <option value="Video Editor">Video Editor</option>
                          </Form.Select>
                        </InputGroup>
                      </Col>

                      {/* Level Dropdown */}
                      <Col md={6}>
                        <Form.Label className="fw-semibold mb-3">Level</Form.Label>
                        <InputGroup className="mb-3">
                          <Form.Select
                            value={selectedLevel}
                            onChange={(e) => setSelectedLevel(e.target.value)}
                          >
                            <option value="" disabled>Select a level</option>
                            <option value="Junior">Junior</option>
                            <option value="Mid">Mid</option>
                            <option value="Senior">Senior</option>
                          </Form.Select>
                        </InputGroup>
                      </Col>
                    </Row>

                    {/* No. of Questions Input */}
                    <Row className="mb-4">
                      <Col>
                        <Form.Label className="fw-semibold mb-3">No of Questions</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter the No of Questions (Ex: min 5 to max 30)"
                          min={5}
                          max={30}
                          value={questionCount}
                          onChange={(e) => {
                            const inputValue = e.target.value;

                            // Always update value so user can type
                            setQuestionCount(inputValue);
                          }}
                        />

                        {questionCount !== '' && (Number(questionCount) < 5 || Number(questionCount) > 30) && (
                          <div className="text-danger mt-1" style={{ fontSize: '0.9rem' }}>
                            Please enter a number between 5 and 30.
                          </div>
                        )}

                      </Col>
                    </Row>
                  </div>
                </Tab>
                <Tab eventKey="existingJob" title="Existing Job">
                  <div className="mt-4">
                    <div className="mb-5">
                      <Form.Label className="fw-semibold mb-3">
                        Select Job Title
                      </Form.Label>
                      <Row className="g-3">
                        {jobTitles.map((title) => (
                          <Col key={title} md={6} lg={4}>
                            <Card
                              as="button"
                              type="button"
                              onClick={() => setSelectedJobTitle(title)}
                              className={`text-start h-100 ${selectedJobTitle === title
                                ? "border-primary bg-primary-subtle"
                                : "border-light"
                                }`}
                            >
                              <Card.Body>
                                <div className="d-flex align-items-center">
                                  <Briefcase className="me-2" size={20} />
                                  <span className="fw-medium">{title}</span>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </div>

                    <div className="mb-5">
                      <Form.Label className="fw-semibold mb-3">
                        Mandatory Skills
                      </Form.Label>

                      <InputGroup className="mb-3" style={{ width: "50%" }}>
                        <Form.Control
                          type="text"
                          value={skillInput}
                          onChange={(e) => setSkillInput(e.target.value)}
                          onKeyPress={(e) => e.key === "Enter" && addSkill()}
                          placeholder="Enter a mandatory skill..."
                        />
                        <Button variant="primary" onClick={addSkill}>
                          Add
                        </Button>
                      </InputGroup>

                      {selectedJobTitle &&
                        suggestedSkills[selectedJobTitle] && (
                          <div className="mb-4">
                            <p className="small fw-medium text-muted mb-2">
                              Suggested skills for {selectedJobTitle}:
                            </p>
                            <div className="d-flex flex-wrap gap-2">
                              {suggestedSkills[selectedJobTitle].map(
                                (skill) => (
                                  <Button
                                    key={skill}
                                    onClick={() => addSuggestedSkill(skill)}
                                    disabled={mandatorySkills.includes(skill)}
                                    variant={
                                      mandatorySkills.includes(skill)
                                        ? "outline-secondary"
                                        : "outline-primary"
                                    }
                                    size="sm"
                                  >
                                    {skill}
                                  </Button>
                                )
                              )}
                            </div>
                          </div>
                        )}

                      {mandatorySkills.length > 0 && (
                        <div>
                          <p className="small fw-medium text-muted mb-2">
                            Selected mandatory skills:
                          </p>
                          <div className="d-flex flex-wrap gap-2">
                            {mandatorySkills.map((skill) => (
                              <Badge
                                key={skill}
                                bg="primary"
                                className="d-flex align-items-center"
                              >
                                {skill}
                                <Button
                                  variant="link"
                                  className="p-0 ms-2 text-white"
                                  onClick={() => removeSkill(skill)}
                                >
                                  <X size={12} />
                                </Button>
                              </Badge>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </Tab>

              </Tabs>

              <div className="d-grid gap-3 d-md-flex">
                <Button
                  onClick={() => setCurrentStep(1)}
                  variant="light"
                  className="flex-grow-1 py-3"
                >
                  Back to Upload
                </Button>
                <Button
                  onClick={analyzeResumes}
                  // disabled={!isFormValid()}
                  disabled={
                    (activeTab === "existingJob" && !canProceedToStep3) ||
                    (activeTab === "manual" && !isFormValid())
                  }
                  className="flex-grow-1 py-3"
                  style={{ backgroundColor: "#97144d", border: "none" }}
                >
                  <Brain className="me-2" size={20} />
                  Analyze Resumes
                </Button>
              </div>
            </Card.Body>
          </Card>
        )}

        {/* Step 3: Results */}
        {currentStep === 3 && (
          <div>
            {isProcessing ? (
              <Card className="border-0 shadow-sm text-center">
                <Card.Body className="p-5">
                  <Spinner
                    animation="border"
                    variant="primary"
                    className="mb-4"
                  />
                  <h3 className="h4 mb-2">Analyzing Resumes</h3>
                  <p className="text-muted mb-4">
                    AI is matching candidates against your requirements...
                  </p>
                  <ProgressBar
                    now={70}
                    animated
                    variant="#97144d"
                    className="mx-auto"
                    style={{ maxWidth: "400px" }}
                  />
                </Card.Body>
              </Card>
            ) : (
              <>
                <Card className="border-0 shadow-sm mb-4">
                  <Card.Body className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div>
                        <h2 className="h3 mb-1">Matching Results</h2>
                        <p className="text-muted mb-0">
                          Job Title:{" "}
                          <span className="fw-medium">{selectedJobTitle}</span>
                        </p>
                      </div>
                      <div className="text-end">
                        <p className="small text-muted mb-0">
                          Total Candidates
                        </p>
                        <p className="h3 mb-0">{analysisResults?.length}</p>
                      </div>
                    </div>

                    <Row className="g-3 mb-4">
                      {["Perfect", "Good", "Average"].map((rating) => {
                        const count = analysisResults?.filter(
                          (r) => r.rating === rating
                        ).length;
                        const variant = {
                          Perfect: "success",
                          Good: "primary",
                          Average: "warning",
                        }[rating];
                        return (
                          <Col key={rating} md={4}>
                            <Card
                              className={`border-${variant} bg-${variant}-subtle`}
                            >
                              <Card.Body className="text-center py-3">
                                <p className="h3 mb-0">{count}</p>
                                <p className="small fw-medium">
                                  {rating} Match
                                </p>
                              </Card.Body>
                            </Card>
                          </Col>
                        );
                      })}
                    </Row>
                  </Card.Body>
                </Card>

                {/* Add the select all and send mail to selected section */}


                <Container className="">
                  <h3 className="my-3">Candidate Analysis Results</h3>
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <div className="form-check d-flex align-items-center mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={analysisResults?.every((c) =>
                          selectedCandidates.includes(c.id)
                        )}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedCandidates(analysisResults?.map((c) => c.id));
                          } else {
                            setSelectedCandidates([]);
                          }
                        }}
                        style={{
                          width: '1.3em',
                          height: '1.3em',
                          borderRadius: '4px',
                          boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
                          border: '1px solid #000',
                          marginRight: '10px'
                        }}
                      />
                      <label className="form-check-label mb-0">Select All</label>
                    </div>

                    {selectedCandidates.length > 0 && (
                      <Button
                        style={{ backgroundColor: "#97144d", border: "none" }}
                        className="mb-2"
                        onClick={handleSendMail}
                      >
                        <FaEnvelope className="me-2" size={16} />
                        Send Mail to Selected ({selectedCandidates.length})
                      </Button>
                    )}
                    <Modal show={showModal} onHide={handleCloseModal}>
                      <Modal.Header closeButton>
                        <Modal.Title>Send Mail</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {console.log(selectedForMail, "selectedForMail==")}
                        {selectedForMail.length > 0 ? (
                          <ul>
                            {selectedForMail.map((candidate) => (
                              <li key={candidate.id}>{candidate.name}</li>
                            ))}
                          </ul>
                        ) : (
                          <p>No candidates selected.</p>
                        )}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                          Cancel
                        </Button>
                        <Button variant="primary" onClick={selectedMailSend} disabled={isSending}>
                          {isSending ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              Sending...
                            </>
                          ) : (
                            "Confirm Send"
                          )}
                        </Button>
                      </Modal.Footer>

                    </Modal>
                  </div>
                  {analysisResults.map((candidate) => {
                    const isExpanded = expandedCards.has(candidate.id);
                    const isSelected = selectedCandidates.includes(candidate.serialNo);

                    return (
                      <Card key={candidate.serialNo} className="mb-4 shadow-sm">
                        {console.log(analysisResults, candidate, "candidate---")}
                        <Card.Body>
                          <Row className="align-items-center mb-3">
                            <Col md={1} className="text-center">
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={isSelected}
                                  onChange={(e) => handleSelection(candidate.serialNo, e.target.checked)}
                                  style={{
                                    width: '1.3em',
                                    height: '1.3em',
                                    borderRadius: '4px',
                                    boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
                                    border: '1px solid #000',
                                    marginLeft: "10px"
                                  }}
                                />
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="d-flex  align-items-start">
                                <div>
                                  <h5>{candidate.name}</h5>
                                  <div className="small text-muted">
                                    <Mail size={14} className="me-1" /> {candidate.email}
                                  </div>
                                  <div className="small text-muted">
                                    <Phone size={14} className="me-1" /> {candidate.mobile}
                                  </div>
                                </div>
                                <Button
                                  variant="link"
                                  className="p-0 ms-2"
                                  onClick={() => {
                                    setEditCandidate({
                                      id: candidate.id, // ✅ Add id here
                                      name: candidate.name,
                                      email: candidate.email,
                                      mobile: candidate.mobile,
                                    });
                                    setShowEditModal(true);
                                  }}
                                >
                                  <FaEdit size={18} />
                                </Button>
                              </div>
                            </Col>
                            <Col md={2} className="text-center">
                              <h4 className={`text-${candidate.color}`}>{candidate.score}%</h4>
                              <div className="small text-muted">Match Score</div>
                            </Col>
                            <Col md={2}>
                              <Badge bg={candidate.color}>{candidate.rating}</Badge>
                            </Col>
                            <Col md={3} className="text-end">
                              {' '}
                              {/* <Button className="mt-2" style={{ backgroundColor: "#97144d", border: "none" }}>
                                <Calendar size={16} className="me-1" /> Send Mail
                              </Button> */}
                              <Button
                                className="mt-1 fw-bold"
                                onClick={() => toggleCardExpansion(candidate.id)}
                                style={{ color: "#97144d", border: "none", backgroundColor: "#fff" }}
                              >
                                {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />} Details
                              </Button>
                            </Col>
                          </Row>
                          <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
                            <Modal.Header closeButton>
                              <Modal.Title>Edit Candidate</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <Form>
                                <Form.Group className="mb-3">
                                  <Form.Label>Name</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={editCandidate.name}
                                    onChange={(e) =>
                                      setEditCandidate({ ...editCandidate, name: e.target.value })
                                    }
                                  />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Email</Form.Label>
                                  <Form.Control
                                    type="email"
                                    value={editCandidate.email}
                                    onChange={(e) =>
                                      setEditCandidate({ ...editCandidate, email: e.target.value })
                                    }
                                  />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Mobile</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={editCandidate.mobile}
                                    onChange={(e) =>
                                      setEditCandidate({ ...editCandidate, mobile: e.target.value })
                                    }
                                  />
                                </Form.Group>
                              </Form>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                                Cancel
                              </Button>
                              <Button
                                variant="primary"
                                onClick={() => {
                                  HandleEdit(editCandidate, editCandidate.id); // ✅ Use the id from state
                                }}
                              >
                                Save Changes
                              </Button>
                            </Modal.Footer>
                          </Modal>

                          {isExpanded && (
                            <>
                              <Row className="mb-3">
                                <Col md={6}>
                                  <h6 className="text-success">Matching Skills</h6>
                                  <div className="d-flex flex-wrap gap-2">
                                    {candidate?.matchedSkills?.length > 0 ? (
                                      candidate.matchedSkills.map((skill, index) => (
                                        <Badge bg="success" key={index}>{skill}</Badge>
                                      ))
                                    ) : (
                                      <p className="text-muted">No matching skills</p>
                                    )}
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <h6 className="text-danger">Missing Skills</h6>
                                  <div className="d-flex flex-wrap gap-2">
                                    {candidate?.missingSkills?.length > 0 ? (
                                      candidate.missingSkills.map((skill, index) => (
                                        <Badge bg="danger" key={index}>{skill}</Badge>
                                      ))
                                    ) : (
                                      <p className="text-muted">No missing skills</p>
                                    )}
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={6}>
                                  <p><strong>Recommendation:</strong> <span className={`text-${candidate.color}`}>{candidate.recommendation}</span></p>
                                  <p><strong>Match Level:</strong> {candidate.matchLevel}</p>
                                </Col>
                                <Col md={6}>
                                  <>
                                    <p>
                                      <strong>Resume:</strong>{' '}
                                      <span
                                        style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                                        onClick={() => setShowPDF(true)}
                                      >
                                        {candidate.fileName}
                                      </span>
                                    </p>

                                    <Modal
                                      show={showPDF}
                                      onHide={() => setShowPDF(false)}
                                      size="xl"
                                      centered
                                      scrollable
                                    >
                                      <Modal.Header closeButton>
                                        <Modal.Title>PDF Viewer - {candidate.fileName}</Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body>
                                        <ResumeViewer fileUrl={`https://cdp-job-portal-v2.s3.ap-south-1.amazonaws.com/PROD/ai_resume/${candidate.fileName}`} />
                                      </Modal.Body>
                                    </Modal>
                                  </>
                                </Col>
                              </Row>

                              <Row>
                                <Col>
                                  <p><strong>Justification:</strong></p>
                                  <p>{candidate.justification}</p>

                                  {candidate?.positive?.length > 0 && (
                                    <>
                                      <p className="text-success"><strong>Positive:</strong></p>
                                      <ul>
                                        {candidate.positive.map((pos, i) => (
                                          <li key={i}>{pos}</li>
                                        ))}
                                      </ul>
                                    </>
                                  )}

                                  {candidate?.negative?.length > 0 && (
                                    <>
                                      <p className="text-danger"><strong>Negative:</strong></p>
                                      <ul>
                                        {candidate.negative.map((neg, i) => (
                                          <li key={i}>{neg}</li>
                                        ))}
                                      </ul>
                                    </>
                                  )}
                                </Col>
                              </Row>
                            </>
                          )}
                        </Card.Body>
                      </Card>
                    );
                  })}
                  {showExtraLoading && (
                    <div className="text-center my-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading more resumes...</span>
                      </div>
                      <p className="mt-2">Analyzing more resumes...</p>
                    </div>
                  )}


                  {/* {selectedCandidates.length > 0 && (
                    <div className="fixed-bottom bg-light p-3 border-top shadow-sm">
                      <Container className="d-flex justify-content-between align-items-center">
                        <span>{selectedCandidates.length} candidate(s) selected</span>
                        <div>
                          <Button variant="primary" className="me-2">Send Bulk Email</Button>
                          <Button variant="success">Schedule Interviews</Button>
                        </div>
                      </Container>
                    </div>
                  )} */}
                </Container>

                {/* <div className="text-center">
                  <Button
                    onClick={() => {
                      setCurrentStep(1);
                      setAnalysisResults([]);
                      setUploadedResumes([]);
                      setSelectedJobTitle("");
                      setMandatorySkills([]);
                      setSelectedCandidates([]);
                      setJobDescription("");
                      uploadResumeData([]);
                    }}
                    variant="light"
                    size="lg"
                  >
                    Start New Analysis
                  </Button>
                </div> */}
              </>
            )}
          </div>
        )}
      </Container>
    </div>
  );
};

export default ResumeParserNew;
